import Tone from 'tone';

export const sortTracksByDependencies = (tracks) => {
    if (Tone.Master.context.isOffline) {
        return tracks;
    }
    // find tracks that have scripts with "trigger.1a" as
    // a string in them
    let dependentTracks = [];
    for (let track of tracks) {
        let hasReceive = track.midiEffects.effects.find(
            x => x.name === "User Script" &&
                x.code.match(/receive\(.*[\"|\'].*\.trigger/));
        if (hasReceive) {
            dependentTracks.push(track);
        }
    }
    let nonDependent = tracks.filter(
        x => !dependentTracks.includes(x));
    return [...nonDependent, ...dependentTracks];
};
